module.exports = __webpack_public_path__ + "static/media/SVID_S_1-1.e8eb0ced.png";